// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__obKEL","footer":"ModalCreateQualiphyProcedure_footer__1PDwl","additionData":"ModalCreateQualiphyProcedure_additionData__1SriY"};